import { httpV2 } from "../http";

const StorageService = {
  listLocations: (params) => httpV2.get("/storage/locations", { params }),
  createLocation: (location) => httpV2.post("/storage/locations", location),
  updateLocation: (locationId, location) => httpV2.put(`/storage/locations/${locationId}`, location),
  deleteLocation: (locationId) => httpV2.delete(`/storage/locations/${locationId}`),
  listItems: (params) => httpV2.get("/storage/items", { params }),
  createItem: (item) => httpV2.post("/storage/items", item),
  updateItem: (itemId, item) => httpV2.put(`/storage/items/${itemId}`, item),
  deleteItem: (itemId) => httpV2.delete(`/storage/items/${itemId}`),
  listStock: (params) => httpV2.get("/storage/stock", { params }),
  createStockAction: (action) => httpV2.post("/storage/stock/actions", action),
  listMovements: (params) => httpV2.get("/storage/movements", { params }),
};

export default StorageService;
